import { render } from "./ViewTourSelection.vue?vue&type=template&id=707fccc4&scoped=true"
import script from "./ViewTourSelection.vue?vue&type=script&lang=ts"
export * from "./ViewTourSelection.vue?vue&type=script&lang=ts"

import "./ViewTourSelection.vue?vue&type=style&index=0&id=707fccc4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-707fccc4"

export default script